export default function PreviousArrow() {
  return (
    <>
      <svg
        className={'md:hidden'}
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="36"
        viewBox="0 0 18 36"
        fill="none"
      >
        <title>Previous chapter</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.99477 16.7965L11.2446 8.54673L13.3066 10.6088L6.08789 17.8276L13.3066 25.0463L11.2446 27.1084L2.99477 18.8586C2.72137 18.5851 2.56779 18.2143 2.56779 17.8276C2.56779 17.4409 2.72137 17.07 2.99477 16.7965Z"
          fill="#C7C7C7"
        />
      </svg>
      <svg
        className={'hidden md:block'}
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="41"
        viewBox="0 0 21 41"
        fill="none"
      >
        <title>Previous chapter</title>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.05192 19.6486L13.4802 10.2203L15.8369 12.5769L7.58691 20.8269L15.8369 29.0769L13.4802 31.4336L4.05192 22.0053C3.73946 21.6927 3.56394 21.2689 3.56394 20.8269C3.56394 20.385 3.73946 19.9611 4.05192 19.6486Z"
          fill="#C7C7C7"
        />
      </svg>
    </>
  )
}
